import { useCallback } from 'react';

import { isFuture, isPast, isToday, secondsToMilliseconds } from 'date-fns';

import { EpgProgram, RBChannel } from 'store/railsBuilder/reducer.types';

import fetchLiveProgram from 'utils/fetchLiveProgram';

function useFindLiveProgram(
    startTime: number,
    programsByChannelsIds: Record<string, EpgProgram[]>,
) {
    return useCallback(
        async ({ editorial: { id: channelId } }: RBChannel) => {
            let liveProgram: undefined | EpgProgram;

            if (
                !programsByChannelsIds[channelId] ||
                !programsByChannelsIds[channelId]?.length ||
                !isToday(startTime)
            ) {
                liveProgram = await fetchLiveProgram(channelId);
            } else {
                liveProgram = programsByChannelsIds[channelId]?.find(
                    ({ period: { start, end } }) =>
                        isPast(secondsToMilliseconds(start)) &&
                        isFuture(secondsToMilliseconds(end)),
                );
            }

            return liveProgram;
        },
        [programsByChannelsIds, startTime],
    );
}

export default useFindLiveProgram;
